import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getMapLayers(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMapLayer>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/maplayer', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMapLayer>>(JSON.parse(data),AloDbMapLayer.createAloDbMapLayerArray)
      }]
    })
  },
  getMapLayer(id:number):AxiosPromise<AlrContainer<AloDbMapLayer>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/maplayer/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMapLayer>(JSON.parse(data),AloDbMapLayer.createAloDbMapLayerWithDetail)
      }]
    })
  },
  saveMapLayer(mapLayer:AloDbMapLayer):AxiosPromise<AlrContainer<AloDbMapLayer>> {
    if(mapLayer.LAY_ID && mapLayer.LAY_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/maplayer/${mapLayer.LAY_ID}`, 
        method: 'PUT',
        data: mapLayer,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMapLayer>(JSON.parse(data),AloDbMapLayer.createAloDbMapLayerWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/maplayer`, 
        method: 'POST',
        data: mapLayer,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMapLayer>(JSON.parse(data),AloDbMapLayer.createAloDbMapLayerWithDetail)
        }]
      })    
    }
    
  },
  deleteMapLayer(id:number):AxiosPromise<AlrContainer<AloDbMapLayer>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/maplayer/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  },
  setGroupName(payload:{layerIds:Array<number>,groupName:string}){
    return  apiHelpers.apiCall({ 
      url: `api/admin/maplayer/setgroupname`, 
      method: 'PUT',
      data: payload,
      transformResponse:[function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMapLayer>>(JSON.parse(data),AloDbMapLayer.createAloDbMapLayerArray)
      }]
    })    
  }
  
}